import img1 from "../../assets/Images/Event Estimate/Event-Estimate.png"
import img2 from "../../assets/Images/Event Estimate/Create-Event-Estimate.png"

export default function EventEstimates() {
    return (
        <div id="event-estimates" className="space-y-16">

            {/* COMMON PAGE HEADER — SAME FORMAT AS ALL PAGES */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    1. Event Estimates
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    Event Estimates allow you to prepare and share a preliminary cost
                    breakdown with customers before confirming a booking.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        The Event Estimates module is designed to help banquet staff provide
                        transparent pricing to customers during initial discussions. Estimates
                        are non-binding and can later be converted into confirmed bookings.
                    </p>
                </section>
            </section>


            {/* ESTIMATE LIST */}
            <section>
                <h2 className="text-xl font-semibold text-[#C9A24E] mb-4">
                    Estimate Listing Screen
                </h2>

                <p className="text-slate-600 max-w-3xl mb-4">
                    When you click on <strong>Event Estimates</strong> from the sidebar,
                    a table opens showing all customers for whom estimates have been created.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-2 mb-6">
                    <li>Each row represents one customer estimate</li>
                    <li>Includes customer name, date, slot, and estimate amount</li>
                    <li>Helps staff quickly track pending or shared estimates</li>
                </ul>

                <div className="rounded-lg">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ADD NEW BUTTON */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h2 className="text-xl font-semibold mb-3">
                    Add New Estimate
                </h2>

                <p className="text-slate-600 mb-4">
                    The <strong>Add New</strong> button is located in the top-right corner
                    of the estimates table. Clicking this button opens the estimate creation form.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Used during customer inquiry or negotiation</li>
                    <li>No booking is created at this stage</li>
                    <li>Multiple estimates can be created for the same date</li>
                </ul>
            </section>

            {/* ESTIMATE FORM */}
            <section>
                <h2 className="text-xl font-semibold text-[#C9A24E] mb-4">
                    Estimate Creation Form
                </h2>

                <p className="text-slate-600 max-w-3xl mb-6">
                    The estimate form captures essential event details and calculates a
                    preliminary cost for the customer.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

                    <div className="bg-white border border-slate-200 rounded-xl p-6">
                        <h3 className="font-semibold mb-2">Basic Information</h3>
                        <ul className="list-disc pl-5 text-slate-600 space-y-1">
                            <li>Estimate date (auto-filled)</li>
                            <li>Function date</li>
                            <li>Day (auto-calculated)</li>
                            <li>Slot (Morning / Evening)</li>
                        </ul>
                    </div>

                    <div className="bg-white border border-slate-200 rounded-xl p-6">
                        <h3 className="font-semibold mb-2">Customer Details</h3>
                        <ul className="list-disc pl-5 text-slate-600 space-y-1">
                            <li>Function Organizer Name</li>
                            <li>Cell number</li>
                            <li>Number of guests</li>
                            <li>Occasion (Wedding, Mehndi, etc.)</li>
                        </ul>
                    </div>
                </div>
                <div className="bg-slate-100 rounded-lg">
                    <img src={img2} alt="" />
                </div>
            </section>

            {/* SERVICES */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h2 className="text-xl font-semibold mb-4">
                    Services & Pricing
                </h2>

                <p className="text-slate-600 mb-4">
                    Services are added to build the estimate cost dynamically.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-2 mb-6">
                    <li>Select service from predefined list</li>
                    <li>Specify quantity and discount (if any)</li>
                    <li>Total is calculated per service line</li>
                </ul>

                <div className="bg-white border border-slate-200 rounded-lg p-6">
                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Banquet Rent</li>
                        <li>Withholding Tax (optional)</li>
                        <li>Sales Tax percentage</li>
                        <li>Other miscellaneous charges</li>
                    </ul>
                </div>
            </section>

            {/* CALCULATION */}
            <section>
                <h2 className="text-xl font-semibold text-[#C9A24E] mb-4">
                    Automatic Total Calculation
                </h2>

                <p className="text-slate-600 max-w-3xl">
                    EventFlow automatically calculates the total estimate amount based on
                    services, taxes, and additional charges. This ensures transparency and
                    avoids manual calculation errors.
                </p>
            </section>

            {/* WHY ESTIMATES */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h2 className="text-xl font-semibold mb-3">
                    Why Event Estimates Matter
                </h2>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Helps customers understand pricing clearly</li>
                    <li>Reduces disputes during final booking</li>
                    <li>Speeds up booking confirmations</li>
                    <li>Improves professionalism and trust</li>
                </ul>
            </section>

            {/* FINAL NOTE */}
            <section className="border-t pt-8">
                <p className="text-slate-600">
                    Estimates can later be converted into confirmed bookings once the
                    customer agrees on pricing and availability.
                </p>
            </section>

        </div>
    );
}
